


































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { formatAltitude, formatDistance } from '~/utils/units.js';
import { difficultyHandle, getSportTags, routeType } from '~/utils/explorer.js';
import { objectIsEmpty } from '~/utils/common.js';

import ProfileRunSportTag from '~/components/partials/ProfileRunSportTag.vue';
import HeartOutline from '~/components/icons/HeartOutline.vue';
import WarningOutline from '~/components/icons/WarningOutline.vue';
import LightningSolid from '~/components/icons/LightningSolid.vue';
import XSolid from '~/components/icons/XSolid.vue';
import SpotOutline from '~/components/icons/SpotOutline.vue';
import LabelsInfos from "~/components/partials/LabelsInfos.vue";
import HandiSolid from "~/components/icons/HandiSolid.vue";

@Component({
  components: {
    HandiSolid,
    LabelsInfos,
    ProfileRunSportTag,
    HeartOutline,
    WarningOutline,
    LightningSolid,
    XSolid,
    SpotOutline,
  },
})
export default class LocalisationRouteCard extends Vue {
  @Prop(Object) route: Types.Route;
  @Prop(Boolean) isInLocalisationContext: false;
  @Prop(Object) destination: {};
  @Prop(Boolean) isExplorerView: false;

  /*
    This tricky computed prevents SSR issues when fetching data
    on page load, as this.news can sometimes be null, and sometimes be {}
  */
  get canShow () {
    if (this.isInLocalisationContext && !objectIsEmpty(this.route)) {
      return true;
    } else if (!this.isInLocalisationContext) {
      return true;
    }
    return false;
  }

  /* Returns translated route type based on type ID */
  get routeType () {
    return routeType(this.route?.type);
  }

  /* Returns distance formatted in the right unit */
  get routeDistance () {
    return this.route?.distance ? formatDistance(this.route?.distance) : '-';
  }

  /* Returns elevation+ formatted in the right unit */
  get elevationPlus () {
    return this.route?.elevation_pos ? formatAltitude(this.route?.elevation_pos) : '-';
  }

  /* Returns elevation- formatted in the right unit */
  get elevationMinus () {
    return this.route?.elevation_neg ? formatAltitude(this.route?.elevation_neg) : '-';
  }

  /* Returns altMax formatted in the right unit */
  get altMax () {
    return this.route?.highest_point ? formatAltitude(this.route?.highest_point) : '-';
  }

  /* Util to return translated route sports if they exist */
  get routeSportTag () {
    return getSportTags(this.route.sport);
  }

  /* Classic computed to get average note of ratings */
  get averageRatesNote () {
    if (this.route.ratings) {
      let sum: number = 0;
      for (var i = 0; i < this.route.ratings.length; i++) {
        sum += this.route.ratings[i].note;
      }
      return sum / this.route.ratings.length;
    }
    return null;
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/route-placeholder.png";
  }

  /* Get associated difficulty object for template informations */
  difficulty (val: number) {
    return difficultyHandle(val);
  }

  get media () {
    if (this.route.ffv_id !== null) {
      return ["/img/sites-ffv.jpg"];
    }
    return this.route.media;
  }
}
